<template>
  <div class="public-header" id="public-header-id">
    <div class="header-top">
      <div class="wrapper">
        <div class="right-module">
          <span v-if="loginState">
            <span class="button-text default no-cursor">{{ userInfo.nickName }}你好, 欢迎登录!&emsp;</span>
            <button class="button-text default" @click="toManage">管理中心</button>&emsp;
            <button class="button-text default" @click="handleLoginOut">[退出]</button>
          </span>
          <button v-else class="button-text default login-button" @click="toLogin">工作人员登录</button>
          <p class="sup-text">客服热线: 010-86091439</p>
        </div>
      </div>
    </div>
    <div class="header-banner">
      <div class="banner-box">
        <div class="banner-logo">
          <img src="../assets/image/header-logo.png" alt="广播影视人才交流中心" class="banner-img" />
          <p class="banner-text">广播影视人才交流中心 培训专栏</p>
        </div>
        <div class="banner-search">
          <input
            class="search-input"
            type="text"
            v-model="searchValue"
            placeholder="请输入内容"
            @keyup.enter="handleSearch"
          />
          <button class="search-but" @click="handleSearch">搜索</button>
        </div>
      </div>
    </div>

    <div class="header-nav">
      <ul class="nav-main">
        <li
          class="main-items"
          v-for="item in navList"
          :key="item.label"
          @click="routerPush(item)"
        >
          <span>{{ item.label }}</span>
          <ul>
            <li
              v-for="sub in item.children || []"
              :key="item.label + sub.label"
              @click="routerPush(sub)"
            >
              {{ sub.label }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- 账号登录 -->
    <el-dialog :visible.sync="dialogVisible" width="412px" class="login-dialog" :close-on-click-modal="false" @close="handleClose">
      <div slot="title" class="section-title">
        <span class="text">账号登录</span>
      </div>
      <div class="form-item">
        <img src="../assets/image/home-user-id-icon.png" alt="账号" class="icon">
        <input type="text" v-model="phone" placeholder="请输入账号" class="form-item-ipt" />
      </div>
      <div class="form-item">
        <img
          src="../assets/image/home-user-password-icon.png"
          alt="密码"
          class="icon"
        >
        <input type="password" v-model="smscode" placeholder="请输入密码" class="form-item-ipt" />
      </div>
      <el-row type="flex" class="form-item">
        <input type="text" v-model="kaptcha" @keyup.enter="handleSubmit" placeholder="请输入验证码" class="form-item-ipt text-inden_16" />
        <img :src="captchUrl" alt="验证码" class="img captch-url" @click="changeCaptchUrl">
      </el-row>
      <div class="login-submit" @click="handleSubmit">登录</div>
    </el-dialog>
  </div>
</template>
<script>
import * as API from '@/api/home/index'
import { EventBus } from '@/libs/eventBus'
import { baseURL } from '@/api/request'
import Cookies from 'js-cookie'

export default {
  name: 'PublicHeader',
  data() {
    return {
      searchValue: '',
      navList: [
        {
          label: '首页',
          routerPath: '/',
          routerQuery: {},
          children: []
        },
        {
          label: '学习平台',
          routerPath: 'training',
          isExternal: true,
          routerQuery: {},
          children: []
        },
        {
          label: '人才培养',
          routerPath: '',
          routerQuery: {},
          children: [
            {
              label: '面授培训',
              routerPath: '/faceList',
              routerQuery: {}
            },
            {
              label: '内训',
              routerPath: '/trainDetail',
              routerQuery: {}
            },
            {
              label: '新职业培训',
              routerPath: '/careerMatrix/7',
              routerQuery: { }
            }
          ]
        },
        {
          label: '人才服务',
          routerPath: '',
          routerQuery: {},
          children: [
            {
              label: '劳务派遣',
              routerPath: '/talentService',
              routerQuery: {
                id: '1'
              }
            },
            {
              label: '职业技能等级认定',
              routerPath: '/talentService',
              routerQuery: {
                id: '5'
              }
            },
            // {
            //   label: '招聘服务',
            //   routerPath: '/talentService',
            //   routerQuery: {
            //     id: '3'
            //   }
            // },
            {
              label: '相关政策及材料下载',
              routerPath: '/talentService',
              routerQuery: {
                id: '4'
              }
            }
          ]
        },
        {
          label: '党建工作',
          routerPath: '/publicInformationList',
          routerQuery: { classifyId: 10 }
        },
        {
          label: '合作申请',
          routerPath: '/cooperationApply',
          routerQuery: {}
        },
        {
          label: '关于我们',
          routerPath: '',
          routerQuery: {},
          children: [
            {
              label: '广电总局人才中心',
              routerPath: '/aboutUs',
              routerQuery: {
                id: '2'
              }
            },
            {
              label: '新广汇贤公司介绍',
              routerPath: '/aboutUs',
              routerQuery: {
                id: '1'
              }
            },
            {
              label: '人才培养计划',
              routerPath: '/aboutUs',
              routerQuery: {
                id: '3'
              }
            }
          ]
        }
      ],
      dialogVisible: false,
      phone: '',
      smscode: '',
      kaptcha: '',
      uuid: '',
      captchUrl: '',
      loginState: false,
      userInfo: {}
    }
  },
  created() {
    this.getToken(false)
  },
  watch: {
    $route() {
      this.getToken(false)
      this.searchValue = this.$route.query.searchValue || ''
    }
  },
  methods: {
    routerPush(row) {
      const { routerPath = '', routerQuery = {}, isExternal = false } = row ?? {}
      if (!routerPath) return
      if (isExternal) {
        switch (routerPath) {
          case 'training':
            if (window.location.href.indexOf('tvpc') > -1) {
              window.open(window.location.href.split('tvpc').join('tvweb'))
            } else {
              window.open('https://training.nrtatalent.cn')
            }
            break
        }
      } else {
        this.$router.push({
          path: routerPath,
          query: routerQuery ?? {}
        })
      }
    },
    handleSearch() {
      const { searchValue } = this
      if (!searchValue) {
        this.$message.error('请输入搜索内容')
        return
      }
      this.$router.push({
        path: '/search',
        query: { searchValue } // 暂时
      })
      EventBus.$emit('searchValue', searchValue)
    },
    toLogin() {
      this.getToken()
      this.dialogVisible = true
    },
    // 获取cookie
    getToken(isLogin = true) {
      const token = Cookies.get('tvToken')
      if (token) {
        this.getUserInfo()
      } else if (isLogin) {
        this.changeCaptchUrl()
      }
    },
    // 获取用户信息
    async getUserInfo() {
      const _userInfo = window.sessionStorage.getItem('tvUserInfo')
      if (_userInfo) {
        this.kaptcha = ''
        this.smscode = ''
        this.phone = ''
        this.loginState = true
        this.userInfo = JSON.parse(_userInfo)
        return
      }
      try {
        const res = await API.getUserInfo()
        const { code, data = {} } = res
        if (code === 0) {
          this.kaptcha = ''
          this.smscode = ''
          this.phone = ''
          this.loginState = true
          this.userInfo = data
          window.sessionStorage.setItem('tvUserInfo', JSON.stringify(data))
          this.$message.success('登录成功!')
          this.handleClose()
        } else {
          throw Error()
        }
      } catch (error) {}
    },
    // 随机串
    randomStr(length) {
      let _string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' // 26个大写字母
      _string += 'abcdefghijklmnopqrstuvwxyz' // 26个小写字母
      _string += '0123456789-' // 10个数字、下划线、连字符
      let _temp = ''
      const _length = _string.length - 1
      for (let i = 0; i < length; i++) {
        // 根据指定长度生成随机字符串
        const n = parseInt(Math.random() * _length) // 获取随机数字
        _temp += _string[n] // 映射成字符串
      }
      return _temp // 返回映射后的字符串
    },
    // 更换验证码
    changeCaptchUrl() {
      const str = this.randomStr(40)
      this.uuid = str
      this.captchUrl = `${baseURL}/auth/login/kaptcha?uuid=${str}`
    },
    async handleSubmit() {
      const { uuid, kaptcha, smscode, phone } = this
      if (!phone) {
        this.$message.warning('请输入账号')
        return
      }
      if (!smscode) {
        this.$message.warning('请输入密码')
        return
      }
      if (!kaptcha) {
        this.$message.warning('请输入验证码')
        return
      }
      const data = { uuid, kaptcha, smscode, phone }
      window.sessionStorage.removeItem('tvUserInfo')
      try {
        const res = await API.toLogin(data)
        const {
          code,
          data: { access_token: accessToken }
        } = res
        if (code === 0) {
          const token = accessToken
          const url = window.location.hostname
          const arr = url.split('.')
          let domain = ''
          if (arr.length > 2) {
            domain = arr.slice(arr.length - 2).join('.')
          } else {
            domain = arr.join('.')
          }
          Cookies.set('tvToken', token, {
            expires: 1,
            domain: `${
              process.env.NODE_ENV === 'development' ? domain : '.' + domain
            }`
          })
          this.getUserInfo()
        }
      } catch (error) {}
    },
    toManage() {
      if (window.location.href.indexOf('tvpc') > -1) {
        window.open(window.location.href.split('tvpc').join('tvui'))
      } else {
        window.open('https://admin.nrtatalent.cn')
      }
    },
    handleLoginOut() {
      const url = window.location.hostname
      const arr = url.split('.')
      let domain = ''
      if (arr.length > 2) {
        domain = arr.slice(arr.length - 2).join('.')
      } else {
        domain = arr.join('.')
      }
      Cookies.remove('tvToken', {
        domain: `${
          process.env.NODE_ENV === 'development' ? domain : '.' + domain
        }`
      })
      window.sessionStorage.removeItem('tvUserInfo')
      this.loginState = false
      this.getToken(false)
    },
    handleClose() {
      this.phone = ''
      this.smscode = ''
      this.kaptcha = ''
      this.uuid = ''
      this.captchUrl = ''
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.public-header {
  .header-top {
    width: 100%;
    height: 48px;
    position: absolute;
    top: 0;
    left: 0;
    backdrop-filter: blur(8px);
    .wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      position: relative;
    }
    .button-text {
      cursor: pointer;
      &.default {
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }
      &.no-cursor {
        font-weight: 600;
        cursor: default;
      }
    }
    .sup-text {
      position: absolute;
      bottom: -20px;
      right: 0;
      font-size: 12px;
      color: #ffffff;
    }
  }
  .header-banner {
    width: 100%;
    height: auto;
    background-image: url(../assets/image/header-bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 86px 0 38px 0;

    .banner-box {
      width: 1300px;
      margin: 0 auto;
      overflow: hidden;
      .banner-logo {
        width: 308px;
        float: left;
        .banner-img {
          width: 100%;
          height: auto;
          display: block;
        }
        .banner-text {
          margin-top: 12px;
          text-align: center;
          font-weight: 600;
          letter-spacing: 2px;
          font-size: 18px;
          color: #FFFFFF;
        }
      }
      .banner-search {
        width: 375px;
        height: 40px;
        box-sizing: border-box;
        padding: 0 16px;
        float: right;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 18px;
        background-color: #ffffff;

        .search-input {
          outline: none;
          background: none;
          border: none;
          font-size: 14px;
          flex: 1;

          &::-webkit-input-placeholder {
            color: #9C9C9C;
            font-size: 14px;
          }

          &:-moz-placeholder {
            color: #9C9C9C;
            font-size: 14px;
          }

          &::-moz-placeholder {
            color: #9C9C9C;
            font-size: 14px;
          }

          &:-ms-input-placeholder {
            color: #9C9C9C;
            font-size: 14px;
          }
        }

        .search-but {
          outline: none;
          border: none;
          width: 64px;
          height: 36px;
          background: #d00d0d;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 8px;
          margin-right: -10px;
          cursor: pointer;
        }
      }
    }
  }

  .header-nav {
    height: 48px;
    background: linear-gradient(0deg, #004bad 0%, #2070d4 100%);

    .nav-main {
      width: 1300px;
      height: 100%;
      margin: 0 auto;

      .main-items {
        float: left;
        box-sizing: border-box;
        width: 14.28%;
        height: 100%;
        cursor: pointer;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        > span {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }

        > ul {
          display: none;
          width: 100%;
          position: absolute;
          left: 0;
          top: 50px;
          z-index: 10001;

          > li {
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            background: #ffffff;
            border: 1px solid #d5d5d5;
            &:hover {
              background: #4b99ff;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
            }
          }
        }

        &:hover {
          background: #d00d0d;
          > ul {
            display: block;
          }
        }
      }
    }
  }
}
.login-dialog {
  ::v-deep .el-dialog {
    .el-dialog__close {
      font-size: 24px;
    }
    .el-dialog__body {
      padding: 32px;
    }
  }
  .form-item {
    width: 100%;
    height: auto;
    position: relative;
    & + .form-item {
      margin-top: 24px;
    }
    .icon {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
    }
    .form-item-ipt {
      width: 100%;
      height: 48px;
      background: #EEF5FF;
      outline: none;
      border: none;
      text-indent: 36px;
      &.text-inden_16 {
        text-indent: 16px;
      }
    }
    .img.captch-url {
      width: 99px;
      height: 48px;
      margin-left: 19px;
    }
  }
  .login-submit {
    width: 349px;
    height: 48px;
    margin-top: 48px;
    background: linear-gradient( 304deg, #0651B4 0%, #517DF8 100%);
    line-height: 48px;
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
  }
}
</style>
